import React, { Component } from 'react';
import { FicheReservation } from '../Fiche/FicheReservation';

import { Immocom } from '../../specifique/immocom';
import { Data } from '../../data/Data';

export class Reservation extends Component {

    constructor(props) {
        super(props);

        //*****************************************************************
        //gestion des paramètres
        //*****************************************************************
        let _letParametreIdOperation = 0;
        let _letParametreIdReservation = 0;

        if (this.props.match !== undefined) {
            if (this.props.match.params.IdOperation !== undefined && this.props.match.params.IdReservation !== undefined) {
                _letParametreIdOperation = parseInt(this.props.match.params.IdOperation);
                _letParametreIdReservation = parseInt(this.props.match.params.IdReservation);
            }
        }
        //*****************************************************************

        this.state = {
            urlV2: '',
            jeton: null,
            idOperation: _letParametreIdOperation,
            idReservation: _letParametreIdReservation,
            onAffichePanelReservation: false
        }
    }

    _getUtilisateurConnecteAinsiQueSonJeton = () => {
        let chargementGetUtilisateurConnecte = Data._chargementGetUtilisateurConnecte();

        chargementGetUtilisateurConnecte
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let valeurRetour = responseFetch.reponseAPIobjet;

                    this.setState({
                        urlV2: valeurRetour[2],
                        jeton: valeurRetour[3],
                        onAffichePanelReservation: true
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.urlV2 = '';
                    stateTemp.jeton = null;
                    stateTemp.onAffichePanelReservation = false;
                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _chargementDonnees = () => {
        if (this.state.idOperation > 0 && this.state.idReservation > 0) {
            this._getUtilisateurConnecteAinsiQueSonJeton();
        }
    };

    _redirectionVersV2 = () => {
        window.location.href = this.state.urlV2 + "/AuthentificationJeton.aspx?Jwt=" + this.state.jeton + "&FctCall=AdministrationDesVentes.aspx";
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    render = () => <FicheReservation
        idOperation={this.state.idOperation}
        idReservation={this.state.idReservation}
        onAffichePanelReservation={this.state.onAffichePanelReservation}
        onFermeFicheReservation={this._redirectionVersV2}
        provientDeADVv2={true}
    />;

}